/**
 * vue filter
 */

import Vue from 'vue'
import MixinUserUtil from '@/assets/mixins/MixinUserUtil';
import { ticketStatusIntToString } from '@/assets/utils/TicketStatusUtil';


Vue.filter("ticketStatusName", ticketStatusIntToString);

// 用户类型
Vue.filter('userTypeChar', function(_type) {
  if( 'SystemUser' == _type ) {
    return "S";
  }

  if( 'MerchantUser' == _type ) {
    return "M";
  }

  if( 'TjkUser' == _type ) {
    return "T";
  }

  return _type;
});


Vue.filter("ticketTime", function( _time ) {
    if(!_time) {
      return _time;
    }
  
    var _fullYear = new Date().getFullYear();
    if( 0 == _time.indexOf(_fullYear + '-') ) {
      return _time.substring(5, _time.lastIndexOf(':'));
    }
  
    var i = _time.indexOf(' ');
    if( i > 0 ) {
      return _time.substring(0, i);
    }
  
    return _time;
});

Vue.filter("ticketUserLabel_2", function(u) {
    if( !u || '{}' == JSON.stringify(u) ) {
      return "";
    }

    if( !!u.name ) {
      return u.name;
    }

    if( !!u.loginName ) {
      return u.loginName;
    }

    return JSON.stringify(u);
});

Vue.filter("ticketUserLabel", function(u) {
    if( !u || '{}' == JSON.stringify(u) || ' ' == u.name ) {
      return "空";
    }

    if( !u.type || !u.name ) {
      return JSON.stringify(u);
    }

    if ( 'SystemUser' == u.type ) {
      return u.name + "(" + u.loginName + ")";
    }

    if ( 'TjkUser' == u.type ) {
      return u.name + "(" + u.loginName + ")";
    }

    if ( 'TicketTrigger' == u.type ) {
      return u.name;
    }

    return u.name;
});


Vue.filter('shopType', _type => {
    if ( '200066' == _type + '') {
      return '语音';
    }

    return _type;
});

var _ellipsis = function( _len ) {
  return function( _txt ) {
    if ( !_txt ) {
      return _txt;
    }

    _txt = _txt + "";

    if ( _txt.length < _len ) {
      return _txt;
    }
  
    return _txt.substring(0, _len) + "...";
  }
};

Vue.filter('ellipsis_50', _ellipsis(50));

Vue.filter('ellipsis_100', _ellipsis(100));

Vue.filter('ellipsis_200', _ellipsis(200));

Vue.filter('ellipsis_500', _ellipsis(500));

Vue.filter('ellipsis_1000', _ellipsis(1000));


Vue.filter("userTypeLabel", MixinUserUtil.methods.userTypeLabel);



// WEBPACK FOOTER //
// ./src/assets/vue-filter.js